import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { Login } from 'src/app/models/login';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { MASKS, NgBrazilValidators } from 'ng-brazil';
import { CedenteService } from 'src/app/services/cedente.service';
import { Auth } from 'src/app/models/auth';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { LocalStoreKeys } from 'src/app/shared/helpers/localstorage/local-store';


@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.css']
})
export class LoginFormComponent implements OnInit {


    public MASKS = MASKS;
    loginFormGroup: FormGroup;
    tries = 4;
    error = false;
    blocked = false;
    private currentUser: Auth;

  constructor(
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private authenticationService: AuthenticationService,
    private alertService: NewAlertService,
    private router: Router,
    private route: ActivatedRoute,
    private cedenteService: CedenteService) {
        localStorage.clear();
    }

    ngOnInit() {
        this.authenticationService.currentUser.subscribe(response => this.currentUser = response);

        if (history.state.logout) this.alertService.error("Sua sessão encerrou, por favor realizar um novo login");
        history.replaceState({}, '');

        this.loginFormGroup = this.formBuilder.group({
        documento: new FormControl('', [
            Validators.required,
            NgBrazilValidators.cpf
        ]),
        password: new FormControl('', [
            Validators.required
        ])
        });
    }

    get form() {
        return this.loginFormGroup.controls;
    }

    onSubmit(login: any) {
        if (this.loginFormGroup.valid) {
            this.authenticationService.newlogin(1,login.documento.replace(/\D+/g, '').replace(' ', ''), login.password).subscribe(
            response => {
                if(response.status == ApiError.Insucesso){
                    this.alertService.warning(response.message);
                    return;
                }

                if (response.status === ApiError.UsuarioBloqueioTemporario) {
                    this.blocked = true;
                }

                if (!response.result.token.authenticated && response.result.assignors == null) {
                    this.tries--;
                    this.error = true;

                    if (this.tries === 0) {
                        this.blocked = true;
                    }

                }
                if(response.result.assignors != null) {
                    this.loginService.changeLogin(new Login(login.documento.replace(/\D+/g, '').replace(' ', ''), login.password));
                    if(response.result.assignors.length == 1){
                        response.result.assignors[0].selected = true;
                        this.authenticationService.setCurrentUserValue(response.result);
                        this.router.navigate(['auth/pin']);
                    }
                    if(response.result.assignors.length > 1){
                        this.authenticationService.setCurrentUserValue(response.result);
                        this.router.navigate(['selectassignor']);
                    }
                }
                if(response.result.assignors == null){
                    response.result.token.isAnonymous = false;
                    response.result.token.userAssignorId = response.result.token.assignorGuid;
                    this.authenticationService.setCurrentUserValue(response.result);
                    this.loginService.changeLogin(null);
                    this.router.navigate(['portal/home']);
                }
            },
            () => this.alertService.error('Não foi possível realizar o login, tente novamente mais tarde')
            );
        }
    }

  register() {
    this.router.navigate(['register']);
  }

  password() {
    this.router.navigate(['password']);
  }
}
